/**
 * A Coupang parcel's QR packs more than its 1D barcode: "<waybill>|<center>|<id>" (V1 OMS read it as
 * "trackingNo|SKU|orderNo"). The waybill is the first field, the same number the parcel's 1D barcode holds,
 * so a QR scan is read as that barcode [SSD-7393]. A code without a pipe is returned as it came.
 */
export const waybillOfParcelQr = (scanned: string): string => scanned.split('|')[0]?.trim() || scanned;
